import { createEvent, createStore } from 'effector';

import { createFactory, invoke } from '@withease/factories';

export const modalFactory = createFactory(() => {
  const openModal = createEvent<void>();

  const closeModal = createEvent<void>();

  const $isModalOpen = createStore(false)
    .on(openModal, () => true)
    .on(closeModal, () => false);

  return {
    openModal,
    closeModal,
    $isModalOpen,
  };
});

export const getModalFactory = () => invoke(() => modalFactory());

export type ModalFactory = ReturnType<typeof getModalFactory>;
